module.exports = __webpack_public_path__ + "img/developer.5f70233f.png";